module.exports = __webpack_public_path__ + "data-table.bce071e976865da51100.eot";


//////////////////
// WEBPACK FOOTER
// ./~/@swimlane/ngx-datatable/assets/fonts/data-table.eot
// module id = 153
// module chunks = 9